/* eslint react/no-unknown-property: 0 */
// first  section for ./index.page.tsx
import { FC } from 'react'
import NextLink from 'next/link'
import Image from 'next/image'
import { useState, useRef, useEffect } from 'react'

import PdMediaSwiper, { MediaItem } from '../../components/pd-media-swiper/pd-media-swiper'

const CircleTag: FC<{ icon: string; text: string }> = ({ icon, text }) => {
  return (
    <div className={['flex flex-col items-center bg-white', 'w-150px', 'laptop:w-64 laptop:gap-y-4'].join(' ')}>
      <div className={['relative', 'w-50px h-50px', 'laptop:w-25 laptop:h-25'].join(' ')}>
        <Image alt="icon" src={icon} layout="fill" />
      </div>
      <span className={['text-center text-black font-normal', 'text-14', 'laptop:text-20 laptop:px-1'].join(' ')}>
        {text}
      </span>
    </div>
  )
}

const CustomerVoice: FC<{ name: string; title: string; content: string; contentBoxHeightClass: string }> = ({
  name,
  title,
  content,
  contentBoxHeightClass,
}) => {
  return (
    <div className="relative w-full laptop:w-110 h-fit pt-23px laptop:pt-10">
      <div
        className={[
          'absolute border border-solid border-[#fc7216] bg-white left-0 top-0 z-10 flex flex-col justify-center',
          'w-311px h-46px  px-4 rounded-lg',
          'laptop:w-416px laptop:h-20  laptop:px-6 laptop:rounded-2xl',
        ].join(' ')}
      >
        <h3 className="text-black/90 text-14 laptop:text-20 font-bold">{name}</h3>
        <p className="text-black/60 text-10 laptop:text-base font-medium">{title}</p>
      </div>

      <div
        className={[
          'bg-[#ffeee2] text-black/90 font-normal',
          'text-14 top-6 rounded-xl pt-34px px-4',
          'laptop:top-12 laptop:text-base laptop:rounded-3xl laptop:pt-14 laptop:px-6',
          contentBoxHeightClass,
        ].join(' ')}
      >
        <p className="w-295px laptop:w-392px">{content}</p>
      </div>
    </div>
  )
}

const SectionThree: FC = () => {
  const [playing, setPlaying] = useState(true)
  const videoRef = useRef(null)

  const sectionClass = ['flex flex-col items-center bg-white w-full relative', 'py-15', 'laptop:py-30'].join(' ')

  const Icon1 = 'https://cdn.pudutech.com/website/images/landingpage-texas/s3-icon1.svg'
  const Icon2 = 'https://cdn.pudutech.com/website/images/landingpage-texas/s3-icon2.svg'
  const Icon3 = 'https://cdn.pudutech.com/website/images/landingpage-texas/s3-icon3.svg'
  const Icon4 = 'https://cdn.pudutech.com/website/images/landingpage-texas/s3-icon4.svg'
  const BtnPlay = 'https://cdn.pudutech.com/website/images/landingpage-texas/btn-play.svg'
  const BtnPause = 'https://cdn.pudutech.com/website/images/landingpage-texas/btn-pause.svg'

  const circleTags = [
    { icon: Icon1, text: '400 Deliveries Per Day' },
    { icon: Icon2, text: '$10/Day for a Usage Period of 5 Years' },
    { icon: Icon3, text: 'Always Punctual' },
    { icon: Icon4, text: '4*10kg Infrared Induction Trays' },
  ]

  const Bella = 'https://cdn.pudutech.com/website/images/landingpage-texas/bella.png'

  function pauseOrPlayVideo() {
    if (!videoRef.current) {
      return
    }

    const videoEl: HTMLVideoElement = videoRef.current as HTMLVideoElement

    if (videoEl.paused) {
      videoEl.play()
      setPlaying(true)
      console.log('video playing')
    } else {
      videoEl.pause()
      setPlaying(false)
      console.log('video paused')
    }
  }

  const mediaSwiperData: MediaItem[] = Array.from({ length: 9 }).map((_, index) => {
    return {
      src: `https://cdn.pudutech.com/website/images/landingpage-texas/0${index + 1}.jpg`,
      type: 'IMG',
      link: '',
      enableMask: false,
    }
  })

  const customerVoices = [
    {
      name: 'Ada Yang',
      title: 'Oner of Ninza Sushi',
      content:
        "“Bella is not a replacement for human workers, but an assistant that we are living in a techno world and it's here to stay.”",
      contentHeightClass: 'laptop:h-152px h-138px',
    },
    {
      name: 'Representative of Chick-fil-A',
      title: '',
      content:
        '“The robots are being piloted as a helping hand to assist Team Members with serving guests in the dining room.”',
      contentHeightClass: 'laptop:h-152px h-30',
    },
    {
      name: 'John Nevin',
      title: 'Owner Manager of Nevins Newfield Inn',
      content:
        '“The server on the floor has more time to spend with the customer, giving them a better service, engage more with them, make sure that they meet their needs and maybe selling more as well.”',
      contentHeightClass: 'laptop:h-224px h-40',
    },
    {
      name: 'Fran Benavides',
      title: 'Manager of Magic Natura Hotel',
      content:
        '“By implementing robots,the staff feel less stress at work. The robots assist them in their daily tasks, such as carrying and delivering dishes, accompanying customers during the service, This not only makes the customers happier but also improves overall work efficiency.”',
      contentHeightClass: 'laptop:h-224px h-50',
    },
  ]

  return (
    <section className={sectionClass}>
      <div
        className={['flex flex-col items-center w-full max-w-300 ', 'px-6 gap-8', 'laptop:px-0 laptop:gap-8'].join(' ')}
      >
        <div className="flex flex-row flex-wrap gap-4 laptop:gap-0 justify-between">
          {circleTags.map((bar) => (
            <CircleTag key={bar.text} icon={bar.icon} text={bar.text} />
          ))}
        </div>

        <div
          className={[
            'relative w-full border-[#fc7216] border-solid overflow-hidden ',
            'rounded-xl border-[5px]',
            'laptop:h-675px laptop:rounded-3xl laptop:border-[10px]',
          ].join(' ')}
        >
          <video
            ref={videoRef}
            className={['border-none aspect-video mx-auto w-full h-full object-cover'].join(' ')}
            autoPlay={true}
            webkit-playsinline="true"
            playsInline
            x-webkit-airplay="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            controls={false}
            controlsList={'nodownload'}
            muted={true}
          >
            <source src="https://cdn.pudutech.com/website/images/landingpage-texas/intro-video.mp4" type="video/mp4" />
          </video>

          <button
            className="absolute border-none m-0  p-0 w-9 h-9 right-3 bottom-3 laptop:w-12 laptop:h-12 laptop:right-12 laptop:bottom-12 rounded-full overflow-hidden"
            onClick={() => pauseOrPlayVideo()}
          >
            <Image alt="pause" src={playing ? BtnPause : BtnPlay} layout="fill" />
          </button>
        </div>
      </div>

      <div className="w-full h-150px laptop:h-110 relative mt-40 mb-8 laptop:mt-31 laptop:mb-24">
        <PdMediaSwiper
          data={mediaSwiperData}
          hidePagination={true}
          hideNavigation={true}
          slideClassName={['!w-266px !rounded-xl', 'laptop:!w-710px laptop:!rounded-3xl overflow-hidden'].join(' ')}
        />
      </div>

      <div
        className={[
          'flex',
          'flex-col gap-8 px-6 w-full ',
          'laptop:px-0 laptop:flex-row laptop:flex-wrap laptop:gap-16 laptop:w-944px',
        ].join(' ')}
      >
        {customerVoices.map((voice) => (
          <CustomerVoice
            key={voice.name}
            name={voice.name}
            title={voice.title}
            content={voice.content}
            contentBoxHeightClass={voice.contentHeightClass}
          />
        ))}
      </div>
    </section>
  )
}

export default SectionThree
